import service from '../../config/axios.config';

export const fetchObjectiveRates = ({ objectiveId }) =>
  service.get(`/objective/${objectiveId}/objectivesRates`);

export const createObjectiveRate = ({ objectiveRate }) =>
  service.post(
    `/objectivesRates`,
    objectiveRate
  );

export const updateObjectiveRate = ({ objectiveRate }) =>
  service.put(
    `/objectivesRates/${objectiveRate.id}`,
    objectiveRate
  );

export const updateObjectiveRateLock = ({ objective }) =>
  service.put(`/objectives/${objective.id}/ratingLock`, objective);
